export default __webpack_public_path__ + "static/media/Interest.2e6697ab.png";